import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Send, X, Sparkles } from "lucide-react";
import { useAssistant } from "../../hooks/useAssistant";
import { AssistantMessages } from "./AssistantMessages";
import { AssistantLeadForm } from "./AssistantLeadForm";

export const AssistantPanel = ({ open, onClose }) => {
  const { messages, loading, error, suggestLead, send, submitLead, dismissLead } = useAssistant();
  const [draft, setDraft] = useState("");

  const submit = (e) => { e.preventDefault(); if (!draft.trim()) return; send(draft); setDraft(""); };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 16, scale: 0.97 }}
          transition={{ duration: 0.2 }}
          className="fixed bottom-24 right-4 sm:right-6 z-50 w-[calc(100vw-2rem)] sm:w-[380px] h-[min(560px,calc(100vh-8rem))] flex flex-col rounded-2xl shadow-2xl border border-slate-200 bg-white overflow-hidden"
          data-testid="assistant-panel"
        >
          <div className="bg-[#0A2342] px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-[#C8A96B]/20 flex items-center justify-center"><Sparkles className="w-4 h-4 text-[#C8A96B]" /></span>
              <div>
                <p className="text-white font-semibold text-sm leading-tight">Nest · AI assistant</p>
                <p className="text-slate-400 text-[11px]">Free for renters · powered by Gemini</p>
              </div>
            </div>
            <button onClick={onClose} className="text-slate-300 hover:text-white" aria-label="Close chat" data-testid="assistant-close"><X className="w-5 h-5" /></button>
          </div>

          <AssistantMessages messages={messages} loading={loading} />
          {error && <p className="px-4 py-2 text-xs text-red-600 bg-red-50 border-t border-red-100" data-testid="assistant-error">{error}</p>}
          {suggestLead && <AssistantLeadForm onSubmit={submitLead} onDismiss={dismissLead} />}

          <form onSubmit={submit} className="border-t border-slate-200 p-2 flex items-center gap-2 bg-white">
            <input
              value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="Ask about areas, budgets, specials…"
              className="flex-1 rounded-full border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#C8A96B]/50"
              maxLength={1500} data-testid="assistant-input"
            />
            <button type="submit" disabled={loading || !draft.trim()} className="w-9 h-9 rounded-full bg-[#0A2342] text-[#C8A96B] flex items-center justify-center disabled:opacity-40 hover:bg-[#1F2A44] transition-colors" aria-label="Send" data-testid="assistant-send">
              <Send className="w-4 h-4" />
            </button>
          </form>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
